// Mappers for Attendance List
import type {
  Attendance,
  LC_AttendanceRecordOut,
  LC_GetEmployeeAttendanceOut,
  AttendancePage,
} from '../types';
import { formatToDdMmYyyy } from '@/utils';

// Status constants for attendance processing
const STATUS_PENDING = 'Por procesar';
const DISPLAY_PENDING = 'Pendiente de procesar';

export function mapRecord(transportRecord: LC_AttendanceRecordOut): Attendance {
  const isPending = transportRecord.statusProcess === STATUS_PENDING;

  return {
    id: String(transportRecord.idAssistance),
    fecha: formatToDdMmYyyy(transportRecord.date),
    hora: transportRecord.hour ?? '',
    tipo: isPending ? DISPLAY_PENDING : (transportRecord.eventType ?? ''),
    ubicacion: transportRecord.ubicationName ?? '',
    dispositivo: transportRecord.deviceInformation ?? '',
    statusProcess: transportRecord.statusProcess ?? '',
  };
}

export function mapPage(
  transportOut: LC_GetEmployeeAttendanceOut,
): AttendancePage {
  const records = (transportOut.data ?? []).map(mapRecord);
  const pagination = transportOut.pagination;
  return {
    data: records,
    page: pagination.currentPage,
    pageSize: pagination.pageSize,
    totalRecords: pagination.totalRecords,
    totalPages: pagination.totalPages,
  };
}
